export default __webpack_public_path__ + "static/media/promocionAlarma6Mobile.fec29631.png";